angular.module('leanlaw').controller('InvoiceEntryEditCtrl', ['$rootScope', '$scope', '$q', '$window', '$location', '$stateParams', '$state', 'userService', 'leanLawApi', 'alerts', function ($rootScope, $scope, $q, $window, $location, $stateParams, $state, userService, leanLawApi, alerts) {
  var user = $scope.user = userService.account;
  $scope.data = {
    clients: []
  };
  var id = $stateParams.entryId;
  if (!id) {
    console.log('entryId required');
    return $state.go('^');
  }
  leanLawApi.listClients().then(list => {
    $scope.data.clients = list.clients;
  });
  var entryLoaded = leanLawApi.getEntry({
    id
  }).then(entry => {
    $scope.entry = entry;
    $scope.startDate = new Date(entry.startTime).setHours(0, 0, 0, 0);
    $scope.startTime = new Date(entry.startTime);
  });
  $scope.save = function () {
    $scope.startDate = new Date($scope.startDate);
    $scope.entry.startTime = new Date($scope.startDate.getFullYear(), $scope.startDate.getMonth(), $scope.startDate.getDate(), $scope.startTime.getHours(), $scope.startTime.getMinutes(), 0);
    $scope.loading = true;
    leanLawApi.updateEntry({
      id: $scope.entry.id,
      body: $scope.entry
    }).then(entry => {
      $state.go('^', {}, {
        reload: true
      });
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
      console.log('failed to save entry', err);
    });
  };
  $scope.mattersForClient = function (clientId) {
    var client = _.find($scope.data.clients, function (c) {
      return c.id == clientId;
    });
    return client ? client.matters : [];
  };
  $scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 0,
    showWeeks: false,
    showButtonBar: false
  };
}]);